module.exports = __webpack_public_path__ + "img/bg-transfer.46f924a4.jpeg";